'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Modal } from '@common/components';
import { useQuery } from '@tanstack/react-query';
import { head } from 'es-toolkit';
import { UnauthQueryOptions } from '@/api';
import { PHOTO_REVIEW_BENEFIT_AMOUNT } from '@/app/donation/_hooks/usePhotoReviewEvent/constants';
import { Image } from '@/components/client';
interface RecommendPhotoReviewModalProps {
  open: boolean;
  onClose?: () => void;
}
export const RecommendPhotoReviewModal = t0 => {
  const $ = _c(19);
  const {
    open,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/home-donation-event"]({
        query: {
          eventCode: "PHOTO_REVIEW_1000"
        }
      }),
      select: _temp,
      staleTime: 0,
      gcTime: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: photoReviewEventData,
    isLoading: isPhotoReviewEventProgressingLoading
  } = useQuery(t1);
  const minDonationAmount = photoReviewEventData?.eventConditionDto?.minDonationAmount ?? 0;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Image src={WELLPOINT_IMAGE_URL} alt={"\uC6F0\uD3EC\uC778\uD2B8 \uC774\uBBF8\uC9C0"} width={110} height={110} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <br />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="pb-12 pt-16 text-center font-700 text-Gray-white typo-body2">포토후기를 남기면{t3}웰포인트 {PHOTO_REVIEW_BENEFIT_AMOUNT.toLocaleString()}원!</p>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== minDonationAmount) {
    t5 = minDonationAmount.toLocaleString();
    $[4] = minDonationAmount;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5) {
    t7 = <p className="pb-24 font-400 text-Y-200 typo-caption1">*웰로에서 {t5}원 이상 기부 시에만 적용돼요. {t6}타 서비스를 통한 기부 시에는 적용이 안됩니다.</p>;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== onClose) {
    t8 = <Button theme="sub-fill" dimensions="H48" onClick={onClose} className="w-full bg-Gray-white">확인</Button>;
    $[9] = onClose;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = <div className="flex flex-col items-center px-20 pb-24 pt-32">{t2}{t4}{t7}{t8}</div>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== isPhotoReviewEventProgressingLoading || $[15] !== onClose || $[16] !== open || $[17] !== t9) {
    t10 = <Modal opened={open} onClose={onClose} className="rounded-large bg-Gray-black !p-0" loading={isPhotoReviewEventProgressingLoading}>{t9}</Modal>;
    $[14] = isPhotoReviewEventProgressingLoading;
    $[15] = onClose;
    $[16] = open;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
const WELLPOINT_IMAGE_URL = 'https://cdn.welfarehello.com/static/wellpoint.png';
function _temp(data) {
  return head(data.context?.contents ?? []);
}